import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchPartFeaturesBulk } from "./fetchPartFeaturesBulk.api";

export const partFeaturesBulkQuery = ({ partIds }: { partIds: string[] }) => ({
  queryKey: queryKeys.parts.featuresBulk(partIds),
  queryFn: () => fetchPartFeaturesBulk({ partIds }),
  staleTime: STALE_TIME,
  enabled: partIds.length > 0,
});
